function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  fill: "#FFFFFF",
  cx: 15,
  cy: 15,
  r: 15
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.34,25v-2l5-10.59a9.41,9.41,0,0,0,.92-4c0-1.37-.77-2.06-1.75-2.06S8.72,7.12,8.72,8.5v1H6.4V8.55A4.11,4.11,0,0,1,7.54,5.42a4.36,4.36,0,0,1,3-1.09,4.08,4.08,0,0,1,2.87,1,4.19,4.19,0,0,1,1.21,3.21,11.79,11.79,0,0,1-1.18,4.63l-4.56,9.7h5.74V25Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.36,14.7V8.1c0-.84-.28-1.86-1.38-1.89A1.69,1.69,0,0,0,19.19,8.1v6.6h-2.1V4.56h2v.86a5.63,5.63,0,0,1,.81-.65,3.12,3.12,0,0,1,1.62-.44,3.29,3.29,0,0,1,2.15.85,2.84,2.84,0,0,1,.76,2.28V14.7Z"
});

var SvgTwoNLogo = function SvgTwoNLogo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 30 30",
    height: "30px",
    width: "30px",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTwoNLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/two-n-logo.248960ee.svg";
export { ForwardRef as ReactComponent };